import { createElement, useEffect } from "react";
import {
	useParams,
	useNavigate,
	useLocation,
	useSearchParams,
} from "react-router-dom";
import useAuthStore from "./data/stores/authStore";

const GeneratePage = (pageName: string, folder: string) => {
	const component = () => require(`./${folder}/${pageName}`).default;
	let navigate = useNavigate();

	try {
		return createElement(component());
	} catch (e) {
		console.log(e);
		navigate("/");
	}
};

const PageRender = () => {
	const { page, id, step } = useParams();
	const { isAuth } = useAuthStore();
	const escape2 = ["notifications", "principal-officer"],
		location = useLocation(),
		navigate = useNavigate(),
		[getSearch] = useSearchParams();
	const newParams = new URLSearchParams(getSearch.toString());

	useEffect(() => {
		if (
			isAuth &&
			(location.pathname === "/login" ||
				location.pathname.startsWith("/login/"))
		) {
			// navigate("/");
			navigate({
				pathname: getSearch?.get("email") ? `/flow` : "/",
				search: `?${newParams.toString()}`,
			});
		}
		if (
			!isAuth &&
			![
				"/",
				"/invitation",
				"/login",
				"/flow",
				"/request",
				"/forgotpassword",
			]?.includes(location.pathname)
		) {
			navigate({
				pathname: getSearch?.get("email") ? `/login` : "/",
				search: `?${newParams.toString()}`,
			});
			navigate("/");
		}
	}, [navigate, isAuth, location]);

	let pageName = "";
	if (step) {
		pageName = `${page}/${id}/${"[id]"}`;
	} else if (id) {
		if (
			(page === "dashboard" && escape2.includes(id)) ||
			(page === "about" && escape2?.includes(id))
		) {
			pageName = `${page}/${id}`;
		} else {
			pageName = `${page}/${"[id]"}`;
		}
	} else {
		pageName = `${page}`;
	}

	return GeneratePage(pageName, isAuth ? "pages" : "screens");
};

export default PageRender;
